import axios from "axios";
import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import type {
  ThreatDefenseReportLineChart,
  ThreatDefenseReportEngagement,
  ThreatDefenseReportTable,
  RemedialTrainingLineChartItem,
  RemedialTrainingEngagementResponse,
  RemedialTrainingUserItem,
  ThreatDefenseReportTablePeople,
} from "features/Library/SimulatedPhishing/Campaigns/Details/types";
import { serializeArrayAndFilterNullable } from "utils/queryUtils";

type ThreatDefenseCampaignParams = {
  campaignId?: number;
} & BasePerformanceRequestFilterParams;

type ThreatDefenseCampaignRunParams = {
  campaignRunId?: number;
} & ThreatDefenseCampaignParams;

export const THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_LINE_CHART_ENDPOINT = "/api/reports/v1/tdf/linechart";
export const THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_ENGAGEMENT_ENDPOINT = "/api/reports/v1/tdf/engagement";
export const THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_TABLE_ENDPOINT = "/api/reports/v1/tdf/campaign-runs";
export const THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_PEOPLE_TABLE_ENDPOINT = "/api/reports/v1/tdf/campaign-run-users";

export const THREAT_DEFENSE_REPORT_LINE_CHART_REMEDIAL_TRAINING_ENDPOINT =
  "/api/reports/v1/tdf/remedial-training/linechart";
export const THREAT_DEFENSE_REPORT_ENGAGEMENT_REMEDIAL_TRAINING_ENDPOINT =
  "/api/reports/v1/tdf/remedial-training/engagement";
export const THREAT_DEFENSE_REPORT_REMEDIAL_TRAINING_PEOPLE_TABLE_ENDPOINT =
  "/api/reports/v1/tdf/remedial-training/users";

export const THREAT_DEFENSE_CAMPAIGN_EXPORT_ENDPOINT = "/api/dataexport/v1/tdf/user-progress";
export const THREAT_DEFENSE_REPORT_REMEDIAL_TRAINING_EXPORT_ENDPOINT =
  "/api/dataexport/v1/tdf/remedial-training/user-progress";

export const threatDefenseReportingService = {
  getPhishingCampaignLineChart: (params: ThreatDefenseCampaignRunParams, signal: AbortSignal) =>
    axios.get<ThreatDefenseReportLineChart[]>(THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_LINE_CHART_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),

  getPhishingCampaignEngagement: (params: ThreatDefenseCampaignRunParams, signal: AbortSignal) =>
    axios.get<ThreatDefenseReportEngagement>(THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_ENGAGEMENT_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),

  getPhishingCampaignTable: (params: ThreatDefenseCampaignParams, signal: AbortSignal) =>
    axios.get<ThreatDefenseReportTable[]>(THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_TABLE_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getPhishingCampaignPeopleTable: (params: ThreatDefenseCampaignRunParams, signal: AbortSignal) =>
    axios.get<ThreatDefenseReportTablePeople[]>(THREAT_DEFENSE_REPORT_PHISHING_CAMPAIGN_PEOPLE_TABLE_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getThreatDefenseCampaignExport: (params: ThreatDefenseCampaignParams) =>
    axios.get(THREAT_DEFENSE_CAMPAIGN_EXPORT_ENDPOINT, {
      responseType: "blob",
      params,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getThreatDefenseRemedialTrainingExport: (params: ThreatDefenseCampaignParams) =>
    axios.get(THREAT_DEFENSE_REPORT_REMEDIAL_TRAINING_EXPORT_ENDPOINT, {
      responseType: "blob",
      params,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getRemedialTrainingLineChart: (params: ThreatDefenseCampaignParams, signal: AbortSignal) =>
    axios.get<RemedialTrainingLineChartItem[]>(THREAT_DEFENSE_REPORT_LINE_CHART_REMEDIAL_TRAINING_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getRemedialTrainingEngagement: (params: ThreatDefenseCampaignParams, signal: AbortSignal) =>
    axios.get<RemedialTrainingEngagementResponse>(THREAT_DEFENSE_REPORT_ENGAGEMENT_REMEDIAL_TRAINING_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
  getRemedialTrainingPeopleTable: (params: ThreatDefenseCampaignParams, signal: AbortSignal) =>
    axios.get<RemedialTrainingUserItem[]>(THREAT_DEFENSE_REPORT_REMEDIAL_TRAINING_PEOPLE_TABLE_ENDPOINT, {
      params,
      signal,
      paramsSerializer: serializeArrayAndFilterNullable,
    }),
};
